module.exports = __webpack_public_path__ + "static/img/ic_menu3.7ec7af00.png";